import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { deleteGroupSuccess, deleteGroupFailure } from '../actions';
import GroupActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* deleteGroup({ payload }) {
  const url = `${API_BASE_URL}/application-groups/${payload.group}`;

  const response = yield request({
    method: 'delete',
    url,
  });
  if (response.success) {
    yield put(deleteGroupSuccess(payload.group));

    Notify('Group Deleted Successfully!', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
    payload.cb();
  } else {
    yield put(
      deleteGroupFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    networkErrorHandler(response?.statusCode, response?.message);
  }
}

export function* onDeleteGroup() {
  yield takeLatest(GroupActionTypes.DELETE_GROUP, deleteGroup);
}
